import React from 'react';
import { Row, Col, Card, Typography, Badge, Image } from 'antd';
import { 
  SafetyCertificateOutlined, 
  FileTextOutlined,
  EyeOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const LendingLicense: React.FC = () => {
  return (
    <div>
      {/* Page Header */}
      <div className="page-header">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <Title level={1} style={{ color: 'white', marginBottom: '10px' }}>
            Official Licenses & Certificates
          </Title>
          <Paragraph style={{ color: 'white', fontSize: '1.1rem' }}>
            View our official licenses and regulatory certificates
          </Paragraph>
        </div>
      </div>

      {/* Official Certificates Section */}
      <div style={{ padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Official Certificates</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: '#666' }}>
              View our official licensing and regulatory certificates
            </Paragraph>
          </div>
          
          <Row gutter={[40, 40]} justify="center">
            {/* Lending License Certificate */}
            <Col xs={24} sm={24} md={12} lg={12}>
              <Card 
                style={{ 
                  textAlign: 'center', 
                  height: '100%',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
                cover={
                  <div style={{ padding: '20px', background: '#f8f9fa', minHeight: '340px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Image
                      src="/images/MoneyLending.png"
                      alt="Money Lending License Certificate"
                      style={{ 
                        width: '100%',
                        height: '300px',
                        objectFit: 'contain',
                        borderRadius: '8px',
                        border: '2px solid #e8e8e8'
                      }}
                      placeholder={
                        <div style={{ 
                          height: '300px', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          background: '#f0f0f0',
                          borderRadius: '8px'
                        }}>
                          <FileTextOutlined style={{ fontSize: '3rem', color: '#ccc' }} />
                        </div>
                      }
                    />
                  </div>
                }
                actions={[
                  <div key="view" style={{ cursor: 'pointer' }} onClick={() => window.open('/images/MoneyLending.png', '_blank')}>
                    <EyeOutlined style={{ fontSize: '1.2rem' }} />
                  </div>,
                  <div key="text" style={{ cursor: 'pointer' }} onClick={() => window.open('/images/MoneyLending.png', '_blank')}>
                    <Text>Click to view full size</Text>
                  </div>
                ]}
              >
                <Title level={3} style={{ color: '#1890ff', marginBottom: '15px' }}>
                  Money Lending License
                </Title>
                <Paragraph style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  Official money lending license issued by the Federal Capital Territory, 
                  authorizing JEJELY ULTIMATE LIMITED to operate as a licensed money lender in Nigeria.
                </Paragraph>
                <div style={{ marginTop: '20px' }}>
                  <Badge status="success" text="Valid and Active" style={{ fontSize: '1rem' }} />
                </div>
              </Card>
            </Col>

            {/* FCCPC Certificate - same Col size as Lending License */}
            <Col xs={24} sm={24} md={12} lg={12}>
              <Card 
                style={{ 
                  textAlign: 'center', 
                  height: '100%',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
                cover={
                  <div style={{ padding: '20px', background: '#f8f9fa', minHeight: '340px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Image
                      src="/images/Fccpc.png"
                      alt="FCCPC Consumer Protection Certificate"
                      style={{ 
                        width: '100%',
                        height: '300px',
                        objectFit: 'contain',
                        borderRadius: '8px',
                        border: '2px solid #e8e8e8'
                      }}
                      placeholder={
                        <div style={{ 
                          height: '300px', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          background: '#f0f0f0',
                          borderRadius: '8px'
                        }}>
                          <SafetyCertificateOutlined style={{ fontSize: '3rem', color: '#ccc' }} />
                        </div>
                      }
                    />
                  </div>
                }
                actions={[
                  <div key="view" style={{ cursor: 'pointer' }} onClick={() => window.open('/images/Fccpc.png', '_blank')}>
                    <EyeOutlined style={{ fontSize: '1.2rem' }} />
                  </div>,
                  <div key="text" style={{ cursor: 'pointer' }} onClick={() => window.open('/images/Fccpc.png', '_blank')}>
                    <Text>Click to view full size</Text>
                  </div>
                ]}
              >
                <Title level={3} style={{ color: '#52c41a', marginBottom: '15px' }}>
                  FCCPC Consumer Protection Certificate
                </Title>
                <Paragraph style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  Certificate from the Federal Competition and Consumer Protection Commission 
                  ensuring compliance with consumer protection regulations and fair lending practices.
                </Paragraph>
                <div style={{ marginTop: '20px' }}>
                  <Badge status="success" text="Consumer Protection Compliant" style={{ fontSize: '1rem' }} />
                </div>
              </Card>
            </Col>
          </Row>

        </div>
      </div>
    </div>
  );
};

export default LendingLicense;
